export const OrderOnlineErrorsMsg = {
    order_online_not_available: "Sorry, we are closed at this moment.",
    empty_cart: "Your shopping cart is empty.",
    pickup_not_available: "Pickup orders are currently not available.",
    pickup_min_order_amount_not_met: "Please add items to meet the minimum order amount for pickup.",
    eat_in_not_available: "Eat in orders are currently not available.",
    delivery_address_not_provided: "Please fill all required fields.",
    delivery_not_available: "Sorry, delivery orders are currently not available.",
    delivery_area_not_covered: "Sorry, delivery is not available for your location.",
    delivery_min_order_amount_not_met: "Please add items to meet the minimum order amount for delivery.",
    cash_payment_not_available: "Cash payments are currently not available.",
    stripe_payment_not_available: "Credit card payments are currently not available.",
    paypal_payment_not_available: "PayPal payments are currently not available.",
    some_products_not_available: "Some products in your shopping cart are not available, items have been removed from your cart, check your shopping cart and order again.",
}

/*
 case ORDER_ONLINE_NOT_AVAILABLE = "order_online_not_available";
case EMPTY_CART = "empty_cart";
case PICKUP_NOT_AVAILABLE = "pickup_not_available";
case PICKUP_MIN_ORDER_AMOUNT_NOT_MET = "pickup_min_order_amount_not_met";
case DELIVERY_ADDRESS_NOT_PROVIDED = "delivery_address_not_provided";
case DELIVERY_NOT_AVAILABLE = "delivery_not_available";
case DELIVERY_AREA_NOT_COVERED = "delivery_area_not_covered";
case DELIVERY_MIN_ORDER_AMOUNT_NOT_MET = "delivery_min_order_amount_not_met";
case CASH_PAYMENT_NOT_AVAILABLE = "cash_payment_not_available";
case STRIPE_PAYMENT_NOT_AVAILABLE = "stripe_payment_not_available";
case PAYPAL_PAYMENT_NOT_AVAILABLE = "paypal_payment_not_available";
case SOME_PRODUCTS_NOT_AVAILABLE = "some_products_not_available";
*/